import { SCREENER_BLANK_VALUE, SCREENER_PROMPT_TOKEN_REGEX } from '../../../utilities';

import styles from '../_index.module.scss';

export const renderTextWithBlankTokens = (template: string | undefined, keyPrefix: string) => {
  if (!template) return null;

  const nodes = [];
  let lastIndex = 0;
  let match;

  SCREENER_PROMPT_TOKEN_REGEX.lastIndex = 0;
  while ((match = SCREENER_PROMPT_TOKEN_REGEX.exec(template)) !== null) {
    const [fullMatch] = match;
    const index = match.index;

    if (index > lastIndex) {
      nodes.push(
        <span key={`${keyPrefix}-text-${lastIndex}`}>{template.slice(lastIndex, index)}</span>
      );
    }

    nodes.push(
      <span
        className={styles['bank-view-blank-token']}
        data-testid="screener-bank-blank-token"
        key={`${keyPrefix}-blank-${index}`}
      >
        {SCREENER_BLANK_VALUE}
      </span>
    );

    lastIndex = index + fullMatch.length;
  }

  if (lastIndex < template.length) {
    nodes.push(<span key={`${keyPrefix}-text-${lastIndex}`}>{template.slice(lastIndex)}</span>);
  }

  return nodes;
};
